module.exports = __webpack_public_path__ + "static/aboutBg-7b4ddadd0440bec7a29f9765158b8032.svg";